import styled from 'styled-components'

const PageStyle = styled.main.attrs((props) => ({}))`
	padding-top: var(--pageMarginTop);
	padding-bottom: var(--pageMarginBottom);

	&.productIndividual {
		padding-top: unset;
		padding-bottom: unset;
	}
`
export default PageStyle
